import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewJobComponent } from './newJob.component';
import {FilterPipe} from "./search-filter.pipe";
import {FormsModule} from "@angular/forms";
import {VarDirective} from "./var.directive";
import { SharedModule } from '../shared/shared.module';
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import {DashboardComponent} from "@uppy/angular";

declare var $ : any;

@NgModule({ declarations: [NewJobComponent, FilterPipe, VarDirective],
    exports: [NewJobComponent],
  imports: [CommonModule, FormsModule, SharedModule, DashboardComponent], providers: [provideHttpClient(withInterceptorsFromDi())] })

export class NewJobModule { }
